"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eeCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var eeCountry = exports.eeCountry = function eeCountry(t) {
  return {
    id: 'EE',
    name: t('Estonia'),
    flag: '🇪🇪',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 5;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 10111 or 80041',
    phonePrefix: '372',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Tallinn',
    currency: 'EUR'
  };
};